import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
	// toAbsoluteUrl,
	checkIsActive
} from "../../../../_helpers";

export function HeaderMenu({ layoutProps }) {
	const location = useLocation();
	const getMenuItemActive = (url) => {
		return checkIsActive(location, url) ? "menu-item-active" : "";
	};

	return (
		<div id="kt_header_menu" className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`} {...layoutProps.headerMenuAttributes}>
			{/*begin::Header Nav*/}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/dashboard")}`}>
					<NavLink className="menu-link" to={"/dashboard"}>
						<span className="menu-text">Dashboard</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				{/*end::1 Level*/}

				<li className={`menu-item menu-item-rel ${getMenuItemActive("/master-user")}`}>
					<NavLink className="menu-link" to={"/master-user"}>
						<span className="menu-text">Master Users</span>
						{/* {layoutProps.rootArrowEnabled && <i className="menu-arrow" />} */}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/subordinate-user")}`}>
					<NavLink className="menu-link" to={"/subordinate-user"}>
						<span className="menu-text">Subordinate Users</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/room-types")}`}>
					<NavLink className="menu-link" to={"/room-types"}>
						<span className="menu-text">Room Types</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/devices")}`}>
					<NavLink className="menu-link" to={"/devices"}>
						<span className="menu-text">Devices</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/device-appliances")}`}>
					<NavLink className="menu-link" to={"/device-appliances"}>
						<span className="menu-text">Device Appliances</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/icons")}`}>
					<NavLink className="menu-link" to={"/icons"}>
						<span className="menu-text">Icons</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/faq")}`}>
					<NavLink className="menu-link" to={"/faq"}>
						<span className="menu-text">FAQ</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel ${getMenuItemActive("/default-settings")}`}>
					<NavLink className="menu-link" to={"/default-settings"}>
						<span className="menu-text">Default Settings</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
				<li className={`menu-item menu-item-rel  ${getMenuItemActive("/firmware-file")}`}>
					<NavLink className="menu-link" to={"/firmware-file"}>
						<span className="menu-text">Firmware Files</span>
						{layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
					</NavLink>
				</li>
			</ul>
			{/*end::Header Nav*/}
		</div>
	);
}
